import {httpClientV2} from "../../infrastructure/http/httpClient";
import {PublicProfileDocument} from "../domain";

type ApiResponse<T> = {
  status: boolean;
  message: string;
  data: T;
};

export type PublicProfilePageState = {
  pageId: number | null;
  publishedRevision: number | null;
  draft: {
    schemaVersion: number;
    document: PublicProfileDocument;
    updatedAt: string;
  } | null;
  published: {
    revision: number;
    schemaVersion: number;
    document: PublicProfileDocument;
    publishedAt: string;
  } | null;
};

export type PublicProfileImageAsset = {
  url: string;
};

export async function getPublicProfilePageState(): Promise<PublicProfilePageState> {
  const response = await httpClientV2.get<ApiResponse<PublicProfilePageState>>(
    "profile/page"
  );
  return response.data;
}

export async function savePublicProfileDraft(
  document: PublicProfileDocument
): Promise<PublicProfilePageState> {
  const response = await httpClientV2.put<ApiResponse<PublicProfilePageState>>(
    "profile/page/draft",
    {document}
  );
  return response.data;
}

export async function publishPublicProfilePage(): Promise<PublicProfilePageState> {
  const response = await httpClientV2.post<ApiResponse<PublicProfilePageState>>(
    "profile/page/publish"
  );
  return response.data;
}

export async function uploadPublicProfileImage(
  file: File
): Promise<PublicProfileImageAsset> {
  const formData = new FormData();
  formData.append("image", file);
  const response = await httpClientV2.post<ApiResponse<PublicProfileImageAsset>>(
    "profile/page/media/image",
    formData
  );
  return response.data;
}
